import { Modal, Box, Typography } from '@mui/material';
import { BasicButton } from 'components/basic-button';
import colors from '../../../constants/colors';
import { iconHandler } from '../../../utils';
import { fontSize, fontWeight, ICON_TYPE } from '../../../constants';
import { useTranslation } from 'react-i18next';

interface SessionExpiryModalProps {
  isOpen: boolean;
  onClose: () => void;
  onLogin: () => void;
}

const SessionExpiryModal = ({ isOpen, onClose, onLogin }: SessionExpiryModalProps) => {
  const { t } = useTranslation();
  return (
    <Modal
      open={isOpen}
      onClose={(_event, reason) => {
        // Only close if reason is NOT 'backdropClick'
        if (reason !== 'backdropClick') {
          onClose();
        }
      }}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
      <Box sx={styles.card}>
        {/* Alert Icon */}
        <Box sx={styles.iconWrapper}>
          <Box className="plusIcon">
            {iconHandler(ICON_TYPE.ALERTOCTAGON, colors.redBright, 1.2, 64)}
          </Box>
        </Box>

        {/* Text */}
        <Typography sx={styles.title}>{t('session.title')}</Typography>
        <Typography sx={styles.subtitle}>{t('session.subtitle')}</Typography>

        <BasicButton
          variant="contained"
          color="primary"
          label={t('signin')}
          onClick={onLogin}
          sx={styles.loginButton}
        />
      </Box>
    </Modal>
  );
};

export default SessionExpiryModal;

const styles = {
  card: {
    background: colors.white,
    width: 600,
    padding: '35px 25px',
    borderRadius: '16px',
    textAlign: 'center',
    position: 'relative',
    outline: 'none !important',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  iconWrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '20px'
  },
  title: {
    fontSize: fontSize.xlarge,
    fontWeight: fontWeight.large,
    marginBottom: '1rem',
    color: colors.grayTitle
  },
  subtitle: {
    fontSize: fontSize.medium,
    fontWeight: fontWeight.medium,
    marginBottom: '2rem',
    background: colors.blueChipBg,
    padding: '15px 0 !important',
    color: colors.grayTitle,
    borderRadius: '30px',
    width: '80%'
  },
  loginButton: {
    width: '10rem',
    fontSize: fontSize.medium,
    fontWeight: fontWeight.medium,
    padding: '15px 0 !important',
    borderRadius: '8px'
  },
  closeIcon: {
    position: 'absolute',
    right: '3%',
    top: '3%',
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  }
};
